import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import store from "./redux/store"; // adjust path if yours differs

import { fetchAccountsItems } from "./redux/slices/AccountsThunks";
import { fetchDefaultItems } from "./redux/slices/DefaultThunks";
import { fetchDisputesItems } from "./redux/slices/DisputesThunks";
import { fetchFaqsItems } from "./redux/slices/FaqsThunks";
import { fetchFeaturedvendorsItems } from "./redux/slices/FeaturedvendorsThunks";
import { fetchIndustry_sector_childItems } from "./redux/slices/Industry_sector_childThunks";
import { fetchIndustry_sector_parentItems } from "./redux/slices/Industry_sector_parentThunks";
import { fetchMembersItems } from "./redux/slices/MembersThunks";
import { fetchReferralpaymentsItems } from "./redux/slices/ReferralpaymentsThunks";
import { fetchReferralsItems } from "./redux/slices/ReferralsThunks";
import { fetchRewardsItems } from "./redux/slices/RewardsThunks";
import { fetchVendor_profile_update_requestsItems } from "./redux/slices/Vendor_profile_update_requestsThunks";
import { fetchVendorrecommendationsItems } from "./redux/slices/VendorrecommendationsThunks";
import { fetchVendorsonhomeItems } from "./redux/slices/VendorsonhomeThunks";
import { fetchVendorItems } from "./redux/slices/VendorThunks";
import { fetchWaitlistItems } from "./redux/slices/WaitlistThunks";

export default function StateLogger() {
  const dispatch = useDispatch();
  const [enabled, setEnabled] = useState(false);

  const defaultItems = useSelector((state) => state.default.items);
  const referralsItems = useSelector((state) => state.referrals.items);
  const vendorItems = useSelector((state) => state.vendor.items);
  const referralpaymentsItems = useSelector(
    (state) => state.referralpayments.items
  );
  const disputesItems = useSelector((state) => state.disputes.items);
  const waitlistItems = useSelector((state) => state.waitlist.items);
  const faqsItems = useSelector((state) => state.faqs.items);
  const featuredvendorsItems = useSelector(
    (state) => state.featuredvendors.items
  );
  const vendorrecommendationsItems = useSelector(
    (state) => state.vendorrecommendations.items
  );
  const accountsItems = useSelector((state) => state.accounts.items);
  const membersItems = useSelector((state) => state.members.items);
  const vendorsonhomeItems = useSelector((state) => state.vendorsonhome.items);
  const rewardsItems = useSelector((state) => state.rewards.items);
  const industry_sector_parentItems = useSelector(
    (state) => state.industry_sector_parent.items
  );
  const industry_sector_childItems = useSelector(
    (state) => state.industry_sector_child.items
  );
  const vendor_profile_update_requestsItems = useSelector(
    (state) => state.vendor_profile_update_requests.items
  );

  // toggle on CMD+U (or CTRL+U)
  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "u") {
        setEnabled((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  // when enabled, dispatch & log
  useEffect(() => {
    if (!enabled) return;
    console.log("🌳 Full Redux Store State:", store.getState());
    dispatch(fetchDefaultItems());
    dispatch(fetchReferralsItems());
    dispatch(fetchVendorItems());
    dispatch(fetchReferralpaymentsItems());
    dispatch(fetchDisputesItems());
    dispatch(fetchWaitlistItems());
    dispatch(fetchFaqsItems());
    dispatch(fetchFeaturedvendorsItems());
    dispatch(fetchVendorrecommendationsItems());
    dispatch(fetchAccountsItems());
    dispatch(fetchMembersItems());
    dispatch(fetchVendorsonhomeItems());
    dispatch(fetchRewardsItems());
    dispatch(fetchIndustry_sector_parentItems());
    dispatch(fetchIndustry_sector_childItems());
    dispatch(fetchVendor_profile_update_requestsItems());
  }, [enabled, dispatch]);

  if (!enabled) return null;

  return (
    <div
      style={{
        fontFamily: "monospace",
        padding: 20,
        background: "#222",
        color: "#0f0",
      }}
    >
      <h2>Redux Slice Data</h2>

      <section>
        <strong>Default:</strong>
        <pre>{JSON.stringify(defaultItems, null, 2)}</pre>
      </section>

      <section>
        <strong>referrals:</strong>
        <pre>{JSON.stringify(referralsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>vendor:</strong>
        <pre>{JSON.stringify(vendorItems, null, 2)}</pre>
      </section>

      <section>
        <strong>referralpayments:</strong>
        <pre>{JSON.stringify(referralpaymentsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>disputes:</strong>
        <pre>{JSON.stringify(disputesItems, null, 2)}</pre>
      </section>

      <section>
        <strong>waitlist:</strong>
        <pre>{JSON.stringify(waitlistItems, null, 2)}</pre>
      </section>

      <section>
        <strong>faqs:</strong>
        <pre>{JSON.stringify(faqsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>featuredvendors:</strong>
        <pre>{JSON.stringify(featuredvendorsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>vendorrecommendations:</strong>
        <pre>{JSON.stringify(vendorrecommendationsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>Accounts:</strong>
        <pre>{JSON.stringify(accountsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>members:</strong>
        <pre>{JSON.stringify(membersItems, null, 2)}</pre>
      </section>

      <section>
        <strong>vendorsonhome:</strong>
        <pre>{JSON.stringify(vendorsonhomeItems, null, 2)}</pre>
      </section>

      <section>
        <strong>Rewards:</strong>
        <pre>{JSON.stringify(rewardsItems, null, 2)}</pre>
      </section>

      <section>
        <strong>Industry_sector_parent:</strong>
        <pre>{JSON.stringify(industry_sector_parentItems, null, 2)}</pre>
      </section>

      <section>
        <strong>Industry_sector_child:</strong>
        <pre>{JSON.stringify(industry_sector_childItems, null, 2)}</pre>
      </section>

      <section>
        <strong>vendor_profile_update_requests:</strong>
        <pre>
          {JSON.stringify(vendor_profile_update_requestsItems, null, 2)}
        </pre>
      </section>
    </div>
  );
}
